import _defineProperty from "@babel/runtime/helpers/defineProperty";
import React from 'react';
import classNames from 'classnames';
import OurTakeHighlight from '@nerdwallet/react-our-take-highlight';
import styles from './keto-product-card.module.less';
export var BaseKetoProductCard = function BaseKetoProductCard(_ref) {
  var _ref2;

  var accordionNode = _ref.accordionNode,
      className = _ref.className,
      driversNode = _ref.driversNode,
      forceMobile = _ref.forceMobile,
      headerNode = _ref.headerNode,
      imageAndRatingNode = _ref.imageAndRatingNode,
      alternateCta = _ref.alternateCta,
      isInCompare = _ref.isInCompare,
      isPreheaderBadge = _ref.isPreheaderBadge,
      ourTakeHighlight = _ref.ourTakeHighlight,
      sectionName = _ref.sectionName;
  return /*#__PURE__*/React.createElement("div", {
    className: classNames([className, styles.ketoProductCardContainer, (_ref2 = {}, _defineProperty(_ref2, styles.ketoProductCardTopMargin, !isPreheaderBadge), _defineProperty(_ref2, styles.ketoProductCardContainerCheckBoxSelected, isInCompare), _defineProperty(_ref2, styles.forceMobile, forceMobile), _ref2)])
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.ketoProductCardHeader
  }, headerNode), /*#__PURE__*/React.createElement("div", {
    className: styles.ketoBody
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.ketoImageAndRatingContainer
  }, imageAndRatingNode), ourTakeHighlight && /*#__PURE__*/React.createElement("div", {
    className: styles.ketoOurTakeWrapper
  }, /*#__PURE__*/React.createElement(OurTakeHighlight, {
    bannerType: ourTakeHighlight.type,
    content: ourTakeHighlight.content,
    analytics: {
      entityName: 'cc_product_our_take_flag',
      sectionName: sectionName
    }
  })), /*#__PURE__*/React.createElement("div", {
    className: styles.ketoProductCardDriversContent
  }, driversNode), alternateCta && /*#__PURE__*/React.createElement("div", {
    className: styles.alternateCta
  }, alternateCta)), /*#__PURE__*/React.createElement("div", {
    className: styles.ketoProductCardAccordion
  }, accordionNode));
};

if (process.env.NODE_ENV !== 'production') {
  // eslint-disable-next-line global-require, @typescript-eslint/no-var-requires
  var PropTypes = require('prop-types');

  BaseKetoProductCard.propTypes = {
    accordionNode: PropTypes.node,
    className: PropTypes.string,
    driversNode: PropTypes.node,
    forceMobile: PropTypes.bool,
    headerNode: PropTypes.node,
    imageAndRatingNode: PropTypes.node,
    alternateCta: PropTypes.node,
    isInCompare: PropTypes.bool,
    isPreheaderBadge: PropTypes.bool,
    sectionName: PropTypes.string
  };
}

export default BaseKetoProductCard;